/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useIntl } from '@exo/frontend-common-i18n';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { ResetPasswordResponse } from '../../components/ForgotPasswordResponse/ForgotPasswordResponse';
import * as S from './ResetPasswordTooManyRequestsErrorPage.styles';

export const ResetPasswordTooManyRequestsErrorPage = () => {
  const history = useHistory();
  const intl = useIntl('features.polaris-login.polaris-login-ui.pages.ResetPasswordTooManyRequestsErrorPage');

  const handlePrevious = () => {
    history.goBack();
  };

  return (
    <ResetPasswordResponse
      title={intl.msg('page.top.title', 'Forgotten Password') as string}
      leftButtonLabel={intl.msg('page.bottom.button.previous', 'Previous') as string}
      leftButtonFn={handlePrevious}
    >
      <S.Error>
        {intl.msg(
          'page.body.text',
          'Too many password resets attempted in recent period.'
        )}
      </S.Error>
    </ResetPasswordResponse>
  );
};
